import { makeObservable, observable, action } from "mobx";

export abstract class BaseStore {
    public isLoading = false;
    public error: string | null = null;

    constructor() {
        makeObservable<BaseStore, "setLoading" | "setError" | "clearError">(this, {
            isLoading: observable,
            error: observable,
            setLoading: action,
            setError: action,
            clearError: action,
        });
    }

    protected setLoading(value: boolean) {
        this.isLoading = value;
    }

    protected setError(error: string | null) {
        this.error = error;
    }

    protected clearError() {
        this.error = null;
    }
}
